export default __webpack_public_path__ + "static/media/KK benar.7c01ab64.jpg";